// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"ded65d7e90ac68b8b141","339":"7e479ef3f72b52693aec"}[chunkId] + ".js";
};